var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"id":"app"}},[_c('Navigation',{attrs:{"drawer":_vm.drawer,"subMenuDrawer":_vm.subMenuDrawer,"showMenu":_vm.showMenu}}),_c('v-container',{staticClass:"mt-5 pl-12"},[_c('v-main',[_c('PasswordChange',{attrs:{"saveNewPwd":(data)=> _vm.saveNewPwd(data)}})],1),_c('Footer')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }